import React, { useState } from 'react';
import { huaweiPrices } from '../priceData';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';

const PricesHuawei = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const services = [
    { id: 'screen', title: 'Skjermbytte', data: huaweiPrices.screen },
    { id: 'battery', title: 'Batteribytte', data: huaweiPrices.battery },
    { id: 'chargingPort', title: 'Ladeport', data: huaweiPrices.chargingPort },
    { id: 'camera', title: 'Kamera', data: huaweiPrices.camera }
  ];

  const filterData = (data) => {
    if (!searchTerm) return data;
    return data.filter(item =>
      item.model.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <div className="min-h-screen pt-32 pb-16">
      {/* Hero */}
      <section className="bg-gradient-to-br from-sky-50 to-cyan-50 py-16 mb-16">
        <div className="container mx-auto px-4 text-center">
          <div className="text-6xl mb-4">📲</div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Huawei Reparasjon <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">Priser</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Huawei P & Mate serier reparasjon med 2 års garanti
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 max-w-6xl">
        {/* Search */}
        <div className="mb-8">
          <Input
            type="text"
            placeholder="Søk etter modell (f.eks. P60 Pro, Mate 50)..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="max-w-md mx-auto border-2 focus:border-sky-600"
          />
        </div>

        {/* Service Sections */}
        <div className="space-y-8">
          {services.map((service) => {
            const filteredData = filterData(service.data);
            if (filteredData.length === 0 && searchTerm) return null;

            return (
              <Card key={service.id} className="border-2">
                <CardHeader className="bg-gradient-to-r from-sky-50 to-cyan-50">
                  <CardTitle className="text-2xl">{service.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b bg-gray-50">
                          <th className="text-left p-4 font-semibold text-gray-900">Modell</th>
                          <th className="text-right p-4 font-semibold text-gray-900">Pris</th>
                          <th className="text-right p-4 font-semibold text-gray-900">Tid</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => (
                          <tr
                            key={index}
                            className="border-b hover:bg-sky-50/50 transition-colors"
                          >
                            <td className="p-4 font-medium text-gray-900">{item.model}</td>
                            <td className="p-4 text-right font-semibold text-sky-600">{item.price}</td>
                            <td className="p-4 text-right text-gray-600">{item.time}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Note */}
        <Card className="mt-8 border-l-4 border-l-sky-600">
          <CardContent className="p-6">
            <p className="text-gray-600">
              <strong className="text-gray-900">Alle priser inkluderer:</strong> 2 års garanti, arbeid og montering. 
              Vi bruker høykvalitets OEM deler for Huawei reparasjoner. 
              Kontakt oss for spørsmål eller pristilbud på andre Huawei modeller.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PricesHuawei;
